import {defineStore} from 'pinia';
import {inject} from "vue";

export interface NotificationState {
    notify: any | null;
}

export const useNotificationStore = defineStore('notificationStore', {
    state: (): NotificationState => ({
        notify: null
    }),
    actions: {
        success(message : string, title = "") {
            this.notify({
                group: "foo",
                title: title,
                type: "success",
                text: message
            }, 3000)
        },
        error(message : string, title = "") {
            this.notify({
                group: "foo",
                title: title,
                type: "error",
                text: message
            }, 3000)
        },
        info(message : string, title = "") {
            this.notify({
                group: "foo",
                title: title,
                type: "info",
                text: message
            }, 3000)
        }
    },
});